import React, { Component } from 'react';
import { Grid, Row, Col, Icon } from 'rsuite';
import { Link } from 'react-router';

class Proceedings extends Component {

  componentDidMount = () => {
    // console.log(this.props)
  }


  render() {
    return (
      <div className="r_container">
        <div className="home">


          <div className="new_banner">
            <div className="banner_content">
              <h1>CSCE 2025</h1>
              <h6>The 2025 World Congress in</h6>
              <h6>Computer Science, Computer Engineering, & Applied Computing (CSCE)</h6>
              <h6>July 21-24, 2025, Las Vegas, USA</h6>
            </div>

            <div className="new_banner_overlay"></div>
          </div>


          <div className="page_content">
            <h4 className="par_header">Proceedings of The World Congress in Computer Science, Computer Engineering, and Applied Computing, CSCE 2025</h4>
            <div className="par">
              <strong>Published in 8 Volumes - see below:</strong>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem', marginTop: '2rem' }}>
                {[
                  {
                    title: "Internet Computing, Internet of Things, Artificial Intelligence, and Applications",
                    conferences: "26th International Conference, ICOMP 2025, and 27th International Conference, ICAI 2025;",
                    congress: "Held as Part of the World Congress in Computer Science, Computer Engineering, and Applied Computing, CSCE 2025, Las Vegas, NV, USA, July 21-24, 2025",
                    editors: "Hamid R. Arabnia, Leonidas Deligiannidis, Ken Ferens, Farid Ghareh Mohammadi, Farzan Shenavarmasouleh, Soheyla Amirian",
                    link: "https://link.springer.com/book/10.1007/978-3-032-22190-2",
                    img: "/static/InternetComputing.webp"
                  },
                  {
                    title: "Distributed Computing, HPC, Cloud Computing, Quantum Technologies, Embedded Systems, Modeling, and Simulation",
                    conferences: "23rd International Conference, ESCS 2025, 21st International Conference, GCC 2025, 4th International Conference, ICEQT 2025, 22nd International Conference, MSV 2025, 31st International Conference, PDPTA 2025;",
                    congress: "Held as Part of the World Congress in Computer Science, Computer Engineering, and Applied Computing, CSCE 2025, Las Vegas, NV, USA, July 21-24, 2025",
                    editors: "Hamid R. Arabnia, Leonidas Deligiannidis, Masami Takata, Miho Chiyonobu, Masahito Ohue, Nobuaki Yasuo, Pablo Rivas, Javier Orduz",
                    link: "https://link.springer.com/book/10.1007/978-3-032-22193-3",
                    img: "/static/DistributedComputing.webp"
                  },
                  {
                    title: "Emerging Trends in Data Science, Information and Knowledge Engineering",
                    conferences: "21st International Conference, ICDATA 2025, and 24th International Conference, IKE 2025;",
                    congress: "Held as Part of the World Congress in Computer Science, Computer Engineering, and Applied Computing, CSCE 2025, Las Vegas, NV, USA, July 21-24, 2025",
                    editors: "Robert Stahlbock, Gary M. Weiss, Hamid R. Arabnia, Leonidas Deligiannidis",
                    link: "https://link.springer.com/book/10.1007/978-3-032-22196-4",
                    img: "/static/EmergingTrendsDS.webp"
                  },
                  {
                    title: "Emerging Trends in Computational Biology, Biomedical Engineering, and Health Informatics",
                    conferences: "26th International Conference, BIOCOMP 2025, 11th International Conference, BIOENG 2025, and 11th International Conference, HIMS 2025;",
                    congress: "Held as Part of the World Congress in Computer Science, Computer Engineering, and Applied Computing, CSCE 2025, Las Vegas, NV, USA, July 21-24, 2025",
                    editors: "Abeer Alsadoon, Farid Ghareh Mohammadi, Farzan Shenavarmasouleh, Soheyla Amirian, Hamid R. Arabnia, Leonidas Deligiannidis",
                    link: "https://link.springer.com/book/10.1007/978-3-032-22199-5",
                    img: "/static/EmergingTrendsCB.webp"
                  },
                  {
                    title: "Frontiers in Education, e-Learning, e-Business, Image Processing, and Computer Vision",
                    conferences: "21st International Conference, FECS 2025, 24th International Conference, EEE 2025, and 29th International Conference, IPCV 2025;",
                    congress: "Held as Part of the World Congress in Computer Science, Computer Engineering, and Applied Computing, CSCE 2025, Las Vegas, NV, USA, July 21-24, 2025",
                    editors: "Hamid R. Arabnia, Leonidas Deligiannidis, Soheyla Amirian, Farzan Shenavarmasouleh, Farid Ghareh Mohammadi, Ashu M. G. Solo",
                    link: "https://link.springer.com/book/10.1007/978-3-032-22202-2",
                    img: "/static/FinEdu.webp"
                  },
                  {
                    title: "Applied Cognitive Computing and Artificial Intelligence",
                    conferences: "27th International Conference, ICAI 2025, and 9th International Conference, ACC 2025;",
                    congress: "Held as Part of the World Congress in Computer Science, Computer Engineering, and Applied Computing, CSCE 2025, Las Vegas, NV, USA, July 21-24, 2025",
                    editors: "Ken Ferens, Leonidas Deligiannidis, Hamid R. Arabnia, David de la Fuente, Jose A. Olivas",
                    link: "https://link.springer.com/book/10.1007/978-3-032-22205-3",
                    img: "/static/AppliedCognitiveComputing.webp"
                  },
                  {
                    title: "Security and Management, Wireless Networks, Software Engineering Research and Practice",
                    conferences: "24th International Conference, SAM 2025, 24th International Conference, ICWN 2025, and 23rd International Conference, SERP 2025;",
                    congress: "Held as Part of the World Congress in Computer Science, Computer Engineering, and Applied Computing, CSCE 2025, Las Vegas, NV, USA, July 21-24, 2025",
                    editors: "Kevin Daimi, Hamid R. Arabnia, Leonidas Deligiannidis",
                    link: "https://link.springer.com/book/10.1007/978-3-032-22208-4",
                    img: "/static/SecuritynManagement.webp"
                  },
                  {
                    title: "Emerging Trends in Scientific Computing and Theoretical Computer Science",
                    conferences: "23rd International Conference, CSC 2025, and 21st International Conference, FCS 2025;",
                    congress: "Held as Part of the World Congress in Computer Science, Computer Engineering, and Applied Computing, CSCE 2025, Las Vegas, NV, USA, July 21-24, 2025",
                    editors: "Hamid R. Arabnia, Douglas D. Hodson, Michael R. Grimaila, Torrey J. Wagner, Peter M. Maurer, Leonidas Deligiannidis",
                    link: "https://link.springer.com/book/10.1007/978-3-032-22211-4",
                    img: "/static/EmergingTrendsSC.webp"
                  }
                ].map((vol, idx) => (
                  <div key={idx} style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'flex-start',
                    gap: '1.5rem',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '12px',
                    padding: '1.5rem',
                    border: '1px solid #e9ecef',
                    boxShadow: '0 4px 6px rgba(0,0,0,0.02)',
                    transition: 'transform 0.2s ease, box-shadow 0.2s ease'
                  }}>
                    <div style={{ flex: '0 0 110px', minWidth: '110px' }}>
                      <img
                        src={vol.img}
                        alt={vol.title}
                        style={{
                          width: '100%',
                          height: 'auto',
                          borderRadius: '6px',
                          boxShadow: '0 4px 10px rgba(0,0,0,0.12)',
                          border: '1px solid #dee2e6',
                          display: 'block'
                        }}
                        onError={(e) => {
                          e.target.src = "https://placehold.co/110x155/e2ebf0/1e293b?text=Book+Cover";
                        }}
                      />
                    </div>
                    <div style={{ flex: '1', display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
                      <h5 style={{ color: '#1a365d', fontWeight: 'bold', margin: 0, fontSize: '1.1rem', lineHeight: '1.4' }}>
                        {vol.title}
                      </h5>
                      <p style={{ margin: 0, fontSize: '0.9rem', color: '#4a5568' }}>
                        <strong>Conferences:</strong> {vol.conferences}
                      </p>
                      <p style={{ margin: 0, fontSize: '0.85rem', color: '#718096', fontStyle: 'italic' }}>
                        {vol.congress}
                      </p>
                      <p style={{ margin: 0, fontSize: '0.9rem', color: '#4a5568' }}>
                        <strong>Co-Editors:</strong> {vol.editors}
                      </p>
                      <div style={{ marginTop: '0.5rem' }}>
                        <a
                          href={vol.link}
                          target="_blank"
                          rel="noopener"
                          className="btn btn-outline-primary btn-sm"
                          style={{ fontSize: '0.8rem', padding: '0.3rem 0.75rem', borderRadius: '6px' }}
                        >
                          View Book on Springer <Icon icon="link" style={{ marginLeft: '5px' }} />
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>


          </div>


        </div>
      </div>
    );
  }
}

export default Proceedings;